"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompEventsRegistrarSym = void 0;
exports.CompEventsRegistrarSym = Symbol.for('CompEventsRegistrar');
//# sourceMappingURL=interfaces.js.map